import Decimal from 'decimal.js'
import moment from 'moment'

export class BankTransferRequestModel {
  constructor(props = {}) {
    this.accountHolder = props.accountHolder || null
    this.iban = props.iban || null
    this.bic = props.bic || null
    this.executionDate = props.executionDate || moment()
    this.purposeDescription = props.purposeDescription || ''
    this.amount = new Decimal(props.amount).abs().toNumber() || 0
    this.bankAccountId = props.bankAccountId || null
  }
}

export default BankTransferRequestModel
